import { NgModule } from '@angular/core';

import { GdprOutagePageComponent } from './gdpr-outage-page.component';

@NgModule({
    imports: [
    ],
    declarations: [
        GdprOutagePageComponent,
    ],
})
export class GdprOutagePageModule { }
